module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"unlockTeamTitle":"Débloquer l\u0027équipe","unlockTeamText":"Voulez-vous débloquer cette équipe ?","unlockTeamBtnNo":"Ne pas débloquer","unlockTeamBtnYes":"Débloquer","unlockBtnTitle":"Débloquer"},"en":{"unlockTeamTitle":"Unlock team","unlockTeamText":"Do you want to unlock this team?","unlockTeamBtnNo":"Do not unlock","unlockTeamBtnYes":"Unlock","unlockBtnTitle":"Unlock"}}')
  delete Component.options._Ctor
}
